import { ref } from 'vue';

const messages = ref([]);

/**
 * @description 警示訊息
 * @param {String} msg 回傳訊息
 * @param {String} cls icon樣式 (只有服飾公版有用到)
 * @param {Function} callback
 */
function showMsg(msg, cls, callback) {
  messages.value.push({ msg, cls, callback });

  setTimeout(() => {
    if (typeof callback === 'function') {
      callback();
    }
    messages.value.splice(0, 1);
  }, 2000);
}

// 這是為不改變太多的寫法給前、後端用的
const allMsgFn = () => {
  const o = {};
  o.success = (msg, callback) => {
    showMsg(msg, 'icon-reminder-ok', callback);
  };

  o.cart = (msg, callback) => {
    showMsg(msg, 'icon-reminder-cart', callback);
  };
  return o;
};
const messageBox = allMsgFn();

// eslint-disable-next-line import/prefer-default-export
function useMsg() {
  return { messages, messageBox, showMsg };
}

export default useMsg;
